import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { IconButton, List } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import * as Styled from './styled';
import { listLogin } from '../../../shared/constants/links';
import isActiveLink from '../../../shared/helpers/isActiveLink';

const LoginContent = ({ handleClick }) => (
  <Styled.Wrapper>
    <Styled.ReturnButton onClick={handleClick} disableRipple>
      <ChevronLeft fontSize="large" />
    </Styled.ReturnButton>
    <List component="nav" aria-label="Links para as páginas do site">
      {listLogin.map(({ route, link, title }, index) => (
        <Styled.NavItem button disableGutters divider={index < listLogin.length - 1} key={`sidebarLink-${index.toString()}`}>
          {
            route
              ? <Link getProps={isActiveLink} to={route} key={title}>{title}</Link>
              : <a href={link} target="_blank" rel="noopener noreferrer">{title}</a>
          }
        </Styled.NavItem>
      ))}
    </List>
  </Styled.Wrapper>
);

LoginContent.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default memo(LoginContent);
